import React from 'react';
import ReactECharts from 'echarts-for-react';
import * as S from './styles';
import { theme } from '../../../styles/theme';

const Graphics = ({ data }) => {
    const COLORS = ['#5BB36E', '#6EBE84', '#7BC391', '#8ECCA2', '#A1D5B3', '#c9e4cd'];

    const processData = (items, qtdReceitas) => {
        const sortedData = items
            .map((item, index) => ({ name: item, value: qtdReceitas[index] }))
            .sort((a, b) => b.value - a.value);

        const topFive = sortedData.slice(0, 5);

        if (sortedData.length > 5) {
            const otherValue = sortedData.slice(5).reduce((sum, item) => sum + item.value, 0);
            topFive.push({ name: 'Outros', value: otherValue });
        }

        return topFive;
    };

    const dataItems = data.culturas || data.produtos || data.pests;
    const qtdReceitas = data.qtdReceitas;

    const processedData = dataItems ? processData(dataItems, qtdReceitas) : [];
    const total = processedData.reduce((sum, item) => sum + item.value, 0);

    const dataWithPercentage = processedData.map(item => ({
        ...item,
        percentage: ((item.value / total) * 100).toFixed(2),
    }));

    const chartData = dataWithPercentage.map((item, index) => ({
        value: item.value,
        name: item.name,
        itemStyle: { color: COLORS[index % COLORS.length] },
    }));

    const option = {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {d}%',
        },
        series: [
            {
                name: 'Items',
                type: 'pie',
                radius: ['75%', '90%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 0,
                    borderColor: `${theme.colors.white.Branco}`,
                    borderWidth: 1,
                },
                label: {
                    show: false,
                    position: 'outside',
                    formatter: '{b}: {d}%',
                },
                data: chartData,
            },
        ],
    };

    return (
        <S.ContainerGraphic>
            <ReactECharts option={option} style={{ width: '100%', height: '100%' }} />

            <S.ContainerGraphicsItem>
                {dataWithPercentage.map((item, index) => (
                    <S.GraphicsItem key={item.name}>
                        <div
                            style={{
                                width: '8px',
                                height: '8px',
                                backgroundColor: COLORS[index % COLORS.length],
                                borderRadius: '16px',
                            }}
                        />
                        <p>{item.name}</p>
                    </S.GraphicsItem>
                ))}
            </S.ContainerGraphicsItem>
        </S.ContainerGraphic>
    );
};

export default Graphics;

